import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-1846e1b3"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "block"
};
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = {
  class: "content-wrapper"
};
const _hoisted_4 = {
  class: "wrapper"
};

const _hoisted_5 = /*#__PURE__*/_createTextVNode("Apply For Partnership");

const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Join the InvestNFT ecosystem now! Be a partner of InvestNFT to enjoy all the benefits. ");

const _hoisted_7 = /*#__PURE__*/_createTextVNode("Apply now");

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "fold"
}, null, -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_content_text = _resolveComponent("content-text");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_content_text, {
    url: "https://docs.google.com/forms/d/1thaz3GiyK4mPPhzlBqJlr0BVDlLVuEurOOes23E9wJk"
  }, {
    title: _withCtx(() => [_hoisted_5]),
    content: _withCtx(() => [_hoisted_6]),
    button: _withCtx(() => [_hoisted_7]),
    _: 1
  })])]), _hoisted_8])]);
}